import { ReactNode } from "react";
import { cn } from "@/lib/utils";

// =============================================================================
// Types
// =============================================================================

export interface DashboardShellProps {
  children: ReactNode;
  className?: string;
}

// =============================================================================
// Dashboard Shell Component
// =============================================================================

/**
 * Wrapper component for dashboard content.
 * Provides consistent spacing and layout for dashboard pages.
 */
export function DashboardShell({ children, className }: DashboardShellProps) {
  return (
    <main
      className={cn(
        "min-h-[calc(100vh-4rem)] bg-slate-50 lg:ml-64",
        className
      )}
    >
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        {children}
      </div>
    </main>
  );
}
